import ChangePassword from './ChangePassword'
export { ChangePassword }
export default ChangePassword
